import NavigationIcon from './NavigationIcon';

import classes from './mapDrawerContent.module.css';

interface Props {
  views: any[];
  activeView: string;
  setActiveView: (view: string) => void;
}

const NavigationControls = ({ views, activeView, setActiveView }: Props) => (
  <div className={classes.iconRow}>
    {views.map(view => {
      return (
        <NavigationIcon
          key={view.value}
          value={view.value}
          label={view.label}
          icon={view.icon}
          activeView={activeView}
          setActiveView={setActiveView}
        />
      );
    })}
  </div>
);

export default NavigationControls;
